import Vue from 'vue';
import Component from 'vue-class-component';
import Organization from '@/tools/models/organization.model';
import {TOOLS_STORE} from '@/tools/store/tools.store';
import {STUDENT_CLICK_EVENTS} from '@/tools/values/student.values';
import EdStudentListComponent from '@/tools/components/ed-student-admin/ed-student-list/ed-student-list.component.vue';
import EdStudentInfoComponent from '@/tools/components/ed-student-admin/ed-student-info/ed-student-info.component.vue';


@Component({
    name: 'student-admin',
    components: {
        EdStudentList: EdStudentListComponent,
        EdStudentInfo: EdStudentInfoComponent
    }
})
export default class StudentAdminView extends Vue {

    /* Data */
    public organization: Organization = new Organization
    public selectedUser: any = null;

    private showStudent(row:any) : void {
        this.selectedUser = row.item;
    }

    private hideStudent() : void {
        this.selectedUser = null;
    }

    /* Hooks */
    created() {
        //-- Get Info Institution
        this.$store.dispatch(`${TOOLS_STORE.ACTIONS.GET_INSTITUTION_INFO}`).then(() => {
            this.organization = this.$store.state.ToolsStore.institutionInfo[0];
        })
    }

    mounted() {
        this.$edEventBus.$on(STUDENT_CLICK_EVENTS.SHOW_STUDENT, this.showStudent);
        this.$edEventBus.$on(STUDENT_CLICK_EVENTS.HIDE_STUDENT, this.hideStudent);
    }

    beforeDestroy() {
        this.$edEventBus.$off(STUDENT_CLICK_EVENTS.SHOW_STUDENT, this.showStudent);
        this.$edEventBus.$off(STUDENT_CLICK_EVENTS.HIDE_STUDENT, this.hideStudent);
    }

}
